import script from "./GameLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./GameLogin.vue?vue&type=script&setup=true&lang=js"

import "../styles/_gameLogin.scss?vue&type=style&index=0&id=5aa5719c&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa5719c"]])

export default __exports__